export function KioskGuaranteeBanner() {
  return (
    <section className="bg-surface-low rounded-4 p-3 d-flex align-items-center gap-3 mt-3">
      <div
        className="rounded-circle bg-surface-highest d-flex align-items-center justify-content-center text-success flex-shrink-0"
        style={{ width: 36, height: 36 }}
      >
        <i className="bi bi-shield-check" style={{ fontSize: 16 }} />
      </div>
      <p className="text-body-sm text-on-surface-variant mb-0">
        <span className="text-label-sm text-on-surface">100% Kiosk Guarantee.</span> If paper jams, toner fades, or
        hardware fails, your payment is refunded automatically within 3 minutes.
      </p>
    </section>
  );
}
